import { Checkbox, Input } from "antd";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { Trans, usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormItem } from "react-hook-form-antd";

import { CreateTenantCurrencySelectSearchable } from "../CreateTenantCurrencySelectSearchable";
import { CreateTenantFormData } from "../formSchema";

const TERMS_URL = "https://paldock.com/general-terms-of-service/";
const PRIVACY_URL = "https://paldock.com/privacy-policy/";

export const TenantInfoStep: FC = () => {
    const { t } = usePaldockTranslation("modals.create-tenant");
    const { t: tFields } = usePaldockTranslation("forms.general-fields");
    const { control, fieldNames } = useGeneralForm<CreateTenantFormData>();

    return (
        <div className="flex flex-col gap-4 pt-4 [&_.ant-form-item]:!mb-0">
            <FormItem control={control} name={fieldNames.title.name} label={t("fields.title.label")} required>
                <Input placeholder={t("fields.title.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.currency_code.name} label={tFields("currency.label")} required>
                <CreateTenantCurrencySelectSearchable placeholder={tFields("currency.placeholder")} />
            </FormItem>
            <FormItem control={control} name={fieldNames.accept_terms.name} valuePropName="checked">
                <Checkbox>
                    <Trans
                        i18nKey="modals.create-tenant.fields.accept_terms.label"
                        components={{
                            termsLink: <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" />,
                            privacyLink: <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" />,
                        }}
                    />
                </Checkbox>
            </FormItem>
        </div>
    );
};
